<fieldset [formGroup]="group" class="w-100 in-one-column">
  <!-- beerProperties subform -->

  <app-beer-properties-subform
    *ngIf="getCtrl('beerProperties')"
    groupName="beerProperties"
  >
  </app-beer-properties-subform>

  <!-- grapeWineProperties subform -->

  <app-grape-wine-properties-subform
    *ngIf="getCtrl('grapeWineProperties')"
    groupName="grapeWineProperties"
  >
  </app-grape-wine-properties-subform>

  <!-- spiritProperties subform -->

  <app-spirit-properties-subform
    class="w-100"
    *ngIf="getCtrl('spiritProperties')"
    groupName="spiritProperties"
  >
  </app-spirit-properties-subform>

  <!-- champagneProperties subform -->

  <app-champagne-properties-subform
    *ngIf="getCtrl('champagneProperties')"
    groupName="champagneProperties"
    [isAlcoholFree]="getCtrl('alcoholFree')?.value"
  >
  </app-champagne-properties-subform>

  <!-- otherAlcoholProperties subform -->

  <app-other-alcohol-properties-subform
    *ngIf="getCtrl('otherAlcoholProperties')"
    groupName="otherAlcoholProperties"
  >
  </app-other-alcohol-properties-subform>
</fieldset>
